import { render } from "./DashSideProfileCard.vue?vue&type=template&id=787c8998"
import script from "./DashSideProfileCard.vue?vue&type=script&lang=js"
export * from "./DashSideProfileCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__